<template>
  <div class="codelogin">
    <div>
      <div class="title">
        邀请码观看
      </div>
      <div class="input_view">
        <div class="phone_view">
          邀请码
          <input class="input_phone" placeholder="请输入邀请码" v-model="invitel_code"/>
        </div>
        <div style="font-size: 12px;padding-left: 120px;padding-top: 24px;">
          <span style="color: #4256FB;">没有邀请码？</span><span>请联系直播管理员获取</span>
        </div>
      </div>
      <el-button :loading="show_invload" class="sumbit" @click="send">
        进入
      </el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'invitelogin',
  props: {
    
  },
  data() {
    return {
      invitel_code:"",
      show_invload:false
    }
  },
  mounted() {
    if(sessionStorage.getItem('inv_code')){
      this.invitel_code = sessionStorage.getItem('inv_code')
    }
  },
  methods: {
    send(){
    if(!this.invitel_code){
      this.$message({
            message: "验证码不能为空",
            type: "error"
      })
      return;
    }
    this.$liveapi.roomwatchytypeinvite(this.invitel_code).then(res=>{
      this.show_invload = true
      if(res.data.code == 200){
        this.show_invload = false
        this.$message({
              message: "验证成功",
              type: "success"
        });
        setTimeout(() => {
            location.reload()
          }, 1000);
      }
      else{
        this.show_invload = false
      }
    }).catch(err=>{
      this.show_invload = false
    })
    },
  },
 
}
</script>
<style scoped>
.codelogin{
    width: 392px;
    height: 500px;
    box-shadow: 0px 4px 16px 0px rgba(0,0,0,0.1500);
    z-index: 2;
    background-color: #fff;
}
.title{
  padding-top: 52px;
  font-size: 20px;
  font-weight: 550;
  text-align: left;
  text-indent: 2em;
  /* margin-top: 20px; */
}
.input_view{
  width: 316px;
  margin: 45px auto;
}
.phone_view{
  padding-left: 16px;
  width: 300px;
  height: 46px;
  background: #EFF6FF;
  text-align: left;
  font-size: 14px;
  color: #555555;
  line-height: 46px;
  border-radius: 5px;
}
.input_phone{
  width:200px;
  margin-left: 8px;
  font-size: 14px;
  padding-left: 16px;
  background-color: transparent;
  border: 0;
  outline: transparent;
  border-left: 1px solid #CEE2FF;
}
/* .smscode_view{
  margin-top: 24px;
  width: 366px;
  height: 56px;
  text-align: left;
  font-size: 20px;
  color: #555555;
  line-height: 56px;
  border-radius: 5px;
} */
.code_phone{
  float: left;
  width:214px;
  height: 56px;
  font-size: 18px;
  padding-left: 16px;
  background: #EFF6FF;
  border: 0;
  outline: transparent;
  border-radius: 5px;
}
.smscode_view>div{
  float: right;
  width: 120px;
  height: 54px;
  border-radius: 5px;
  border: 1px solid #4256FB;
  text-align: center;
  color: #4256FB;
  font-size: 18px;
}
.sumbit{
  width: 316px;
  height: 46px;
  background: linear-gradient(171deg, #3EA2FF 0%, #4558FC 100%);
  border-radius: 30px;
  color: #fff;
  font-size: 16px;
  margin: 129px auto;
}
.slide_verify{
  position: absolute;
  bottom: 160px;
  z-index: 10;
}
</style>
